import React, { useState, useEffect } from 'react'
import favicon from "../assets/favicon.png"
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { loginAPI } from '../utils/api';
import loadingif from "../assets/loading-gif.gif";
import { Col, Form } from 'react-bootstrap';
import { FaRegHandPointRight } from "react-icons/fa";

const Home = () => {
    const [values, setInputValue] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    const agentdata = localStorage.getItem('agentdata');
    useEffect(() => {
        if (agentdata) {
            navigate("/dashboard");
        }
        else {
            navigate("/");
        }
    }, [agentdata]);

    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            setLoading(true);
            loginAPI("sub-admin-send-mobile-otp", values).then((res) => {
                if (res.data.status === 1) {
                    localStorage.setItem("subadminmobile", values.subadmin_mobile);
                    toast.success(res.data.msg);
                    setLoading(false);
                    navigate("/mobile-otp");
                }
                else {
                    setLoading(false);
                    toast.error(res.data.msg);
                }
            })
        }
        setValidated(true);
    }
    const handleInputs = e => {
        setInputValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    return (
        <div className="homePage">
            <Helmet>
                <title>SATKARTAR:ADMIN::SUBADMIN LOGIN</title>
            </Helmet>
            <div className="container h-100">
                <div className="d-flex justify-content-center h-100">
                    <div className="user_card">
                        <div className="d-flex justify-content-center">
                            <div className="brand_logo_container">
                                <img src={favicon} className="brand_logo" alt="Logo" />
                            </div>
                            <h4 className="loginname">SUBADMIN LOGIN</h4>
                        </div>
                        <div className="d-flex justify-content-center form_container">
                            <Form noValidate validated={validated} onSubmit={handleLoginSubmit}>
                                <Form.Group as={Col} md="12" controlId="validationCustom01">
                                    <Form.Label>Enter Mobile Number</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Mobile Number"
                                        onChange={handleInputs}
                                        name="subadmin_mobile"
                                        pattern="[6789][0-9]{9}"
                                        maxLength={10}
                                        minLength={10}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        <FaRegHandPointRight /> Please provide a valid Mobile Number
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <div className="d-flex justify-content-center mt-3 login_container">
                                    {loading ?
                                        <button disabled={true} type="submit" className="btn login_btn">
                                            <img src={loadingif} alt={loadingif} style={{ width: "7%", marginTop: "-3px" }} /> SENDING...
                                        </button>
                                        :
                                        <button type="submit" className="btn login_btn">SEND MOBILE OTP</button>
                                    }
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home
